import { render, staticRenderFns } from "./LouCeng.vue?vue&type=template&id=0be15587&scoped=true&"
import script from "./LouCeng.vue?vue&type=script&lang=js&"
export * from "./LouCeng.vue?vue&type=script&lang=js&"
import style0 from "./LouCeng.vue?vue&type=style&index=0&id=0be15587&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be15587",
  null
  
)

export default component.exports